module.exports = __webpack_public_path__ + "static/img/banner4.56e1d6a7.jpg";